import { useNavigate } from 'react-router-dom';
import { getDate } from '../../../../../utils/dateUtils';

const CreditNoteTable = ({
	column,
	rows,
	handleDelete,
	creditNoteType,
	screenType = 'create',
	isDeleteIcon = true,
	setIsSalesDrawerOpen,
	setIsDrawerOpen,
	setPrId,
}) => {
	const navigate = useNavigate();
	const suburl = localStorage.getItem('suburl');
	return (
		<div
			className="max-w-1297 px-3"
		>
			<table
				style={{ borderCollapse: 'collapse', marginTop: screenType === 'create' ? '20px' : '0px' }}
			>
				<thead>
					<tr style={{ backgroundColor: '#f1f3f5', fontWeight: 'bold', color: '#555B67' }}>
						{column.map((col, index) => (
							<th
								key={index}
								style={{
									padding: '8px',
									border: '1px solid #dee2e6',
									textAlign: index === column.length - 1 ? 'Right' : 'Left',
								}}
							>
								{col}
							</th>
						))}
					</tr>
				</thead>
				<tbody style={{ color: '#555B67', fontWeight: 'bold' }}>
					{rows?.map((cn, index) => (
						<tr
							key={index}
							style={{
								backgroundColor: index === 1 ? '#f0f8ff' : 'transparent',
								height: '50px',
							}}
						>
							{screenType === 'create' || (screenType === 'details' && creditNoteType === 1) ? (
								<td style={{ border: '1px solid #dee2e6', padding: '8px', textAlign: 'left' }}>
									{creditNoteType === 1
										? cn?.date !== null
											? getDate(cn.date)
											: ''
										: cn?.invoice_number}
									<br />
									{screenType === 'create' && creditNoteType === 2 && (
										<span style={{ fontSize: '12px' }}>
											<span style={{ color: '#000000', fontWeight: 'bold' }}>
												{cn?.invoice_date !== null ? getDate(cn?.invoice_date) : ''}
											</span>
										</span>
									)}
								</td>
							) : (
								''
							)}

							<td style={{ border: '1px solid #dee2e6', padding: '5px', textAlign: 'left' }}>
								<strong
									style={{
										color: screenType === 'details' ? '#3B58FF' : '#000',
										cursor: screenType === 'details' ? 'pointer' : undefined,
									}}
									onClick={() => {
										if (screenType === 'details' && creditNoteType === 2) {
											setIsDrawerOpen(false);
											setPrId(cn?.id);
											setIsSalesDrawerOpen(true);
										} else if (screenType === 'details' && creditNoteType === 1) {
											navigate(`/user/${suburl}/sales-return-details/${cn?.sales_return_id}`);
										}
									}}
								>
									{creditNoteType === 1 ? cn?.return_number : cn?.payment_received_number}
								</strong>
								<br />
								{creditNoteType === 2 && (
									<span style={{ fontSize: '12px' }}>
										<span style={{ color: '#000000', fontWeight: 'bold' }}>
											{cn?.pr_date !== null ? getDate(cn?.pr_date) : ''}
										</span>
									</span>
								)}
							</td>

							<td style={{ border: '1px solid #dee2e6', padding: '5px', textAlign: 'left' }}>
								₹
								{creditNoteType === 1
									? Number(cn?.amount).toFixed(2)
									: Number(cn?.totat_amount).toFixed(2)}
							</td>
							{creditNoteType === 1 && isDeleteIcon && (
								<td style={{ border: '1px solid #dee2e6', padding: '5px', textAlign: 'right' }}>
									<button
										className="delete mt-0 bg-transparent"
										onClick={() => handleDelete(cn.id)}
										tabIndex="-1"
									>
										<svg
											width="24"
											height="24"
											viewBox="0 0 24 24"
											fill="none"
										>
											<path
												d="M3 6H5H21"
												stroke="#FF0000"
												strokeWidth="2"
												strokeLinecap="round"
												strokeLinejoin="round"
											/>
											<path
												d="M19 6V20C19 20.5304 18.7893 21.0391 18.4142 21.4142C18.0391 21.7893 17.5304 22 17 22H7C6.46957 22 5.96086 21.7893 5.58579 21.4142C5.21071 21.0391 5 20.5304 5 20V6M8 6V4C8 3.46957 8.21071 2.96086 8.58579 2.58579C8.96086 2.21071 9.46957 2 10 2H14C14.5304 2 15.0391 2.21071 15.4142 2.58579C15.7893 2.96086 16 3.46957 16 4V6"
												stroke="#FF0000"
												strokeWidth="2"
												strokeLinecap="round"
												strokeLinejoin="round"
											/>
											<path
												d="M10 11V17"
												stroke="#FF0000"
												strokeWidth="2"
												strokeLinecap="round"
												strokeLinejoin="round"
											/>
											<path
												d="M14 11V17"
												stroke="#FF0000"
												strokeWidth="2"
												strokeLinecap="round"
												strokeLinejoin="round"
											/>
										</svg>
									</button>
								</td>
							)}
							{creditNoteType === 2 && (
								<td style={{ border: '1px solid #dee2e6', padding: '5px', textAlign: 'right' }}>
									₹ {Number(cn?.excess_payment_amount).toFixed(2)}
								</td>
							)}
						</tr>
					))}
				</tbody>
			</table>
		</div>
	);
};
export default CreditNoteTable;
